import type { CurrentCommunity } from "@/react/types/CurrentCommunity";
import { useRouterQueryParams } from "@circle-react/hooks/useRouterQueryParams";

export const useOnboardingWhiteLabel = (
  currentCommunity?: CurrentCommunity,
) => {
  const { request_host } = useRouterQueryParams();

  const rootUrl = currentCommunity?.root_url;
  const isWhiteLabelEnabled = currentCommunity?.white_label;

  // eslint-disable-next-line sonarjs/different-types-comparison -- Disabled for plugin version update. Fix when possible
  const isAdminLogin = request_host === rootUrl;

  return {
    shouldShowPoweredByCircle: !isWhiteLabelEnabled && !isAdminLogin,
  };
};
